// extracted by mini-css-extract-plugin
export default {"headerRow":"KoGYXA_2lCkPjudS2Np8"};